import React, { createContext, useContext, useState, useEffect } from "react";

// 1️⃣ Crear el contexto
const PatologiaContext = createContext();

// 2️⃣ Provider que envolverá tu app o rutas privadas
export const PatologiaProvider = ({ children }) => {
  const [patologiaActiva, setPatologiaActiva] = useState("");

  // Cargar la patología activa desde localStorage al iniciar
  useEffect(() => {
    const storedPatologia = localStorage.getItem("patologiaActiva");
    if (storedPatologia) {
      setPatologiaActiva(storedPatologia);
    }
  }, []);

  // Guardar automáticamente en localStorage cada vez que cambie
  useEffect(() => {
    if (patologiaActiva) {
      localStorage.setItem("patologiaActiva", patologiaActiva);
    }
  }, [patologiaActiva]);

  return (
    <PatologiaContext.Provider value={{ patologiaActiva, setPatologiaActiva }}>
      {children}
    </PatologiaContext.Provider>
  );
};

// 3️⃣ Hook para usar el contexto más fácilmente
export const usePatologia = () => {
  const context = useContext(PatologiaContext);
  if (!context) {
    throw new Error("usePatologia debe usarse dentro de un PatologiaProvider");
  }
  return context;
};